<template>
  <div
    v-if="showTooltip"
    class="tooltip"
    :style="{
      top: positionTop,
      left: positionLeft,
    }"
    ref="tooltip"
  >
    <div class="tooltip-inner">
      <span>{{ title }}</span>
      <p>{{ body }}</p>
    </div>
  </div>
</template>

<script>
import { tooltipContent } from "../../constants/js/tooltip-content";
import { EventBus } from "../../constants/js/event-bus";

export default {
  name: "ToolTip",
  props: {
    name: String,
  },
  data() {
    return {
      showTooltip: false,
      positionTop: 0,
      positionLeft: 0,
      tooltipContent: tooltipContent,
      title: null,
      body: null,
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    isMobile() {
      return this.$isMobileDevice();
    },
    isMobileSize() {
      return this.windowWidth <= 1057;
    },
  },
  methods: {
    calculatePosition() {
      const rect = this.$el.parentNode.getBoundingClientRect();
      this.positionY = -rect.height;
    },
    show() {
      this.showTooltip = true;
    },
    hide() {
      this.showTooltip = false;
    },

    determineTooltipContent() {
      const tooltipData = this.tooltipContent.find(
        (tooltip) => tooltip.name === this.name
      );
      if (!!tooltipData) {
        this.title = tooltipData.title;
        this.body = tooltipData.body;
      } else {
        this.title = "Missing Tooltip";
        this.body = "The requested tooltip is not available.";
      }
    },
    calculateMousePosition(event) {
      let mouseX, mouseY;
      if (this.isMobile) {
        mouseX = event.touches ? event.touches[0].clientX : event.clientX;
        mouseY = event.touches ? event.touches[0].clientY : event.clientY;
        if (window.innerWidth <= 480) {
          this.positionLeft = "10%";
        } else if (window.innerWidth <= 1024) {
          this.positionLeft = `${mouseX - mouseX / 2}px`;
        } else {
          this.positionLeft = `${mouseX - mouseX / 3.33}px`;
        }

        this.positionTop = `${mouseY - 111}px`;
      } else if (this.isMobileSize) {
        mouseX = event.clientX;
        mouseY = event.clientY;
        this.positionLeft = "10%";
        this.positionTop = `${mouseY - 111}px`;
      } else {
        mouseX = event.clientX;
        mouseY = event.clientY;
        const viewportWidth = window.innerWidth;
        const distanceFromRight = viewportWidth - mouseX;
        if (distanceFromRight < 380) {
          this.positionLeft = `${mouseX - 111}px`;
        } else {
          this.positionLeft = `${mouseX + 22}px`;
        }

        this.positionTop = `${mouseY - 111}px`;
      }
    },
    handleScroll() {
      this.hide();
    },
    handleClick(event) {
      this.calculateMousePosition(event);
      if (!this.showTooltip) {
        EventBus.$emit("tooltip-opened", this);
        this.show();
      } else {
        this.hide();
      }
    },
    onTooltipOpened(openedTooltip) {
      if (openedTooltip !== this) {
        this.hide();
      }
    },
    handleWidth() {
      this.windowWidth = window.innerWidth;
    },
  },
  mounted() {
    this.determineTooltipContent();
    this.$nextTick(() => {
      EventBus.$on("tooltip-opened", this.onTooltipOpened);
      if (this.isMobile) {
        window.addEventListener("scroll", this.handleScroll);
        this.$el.parentNode.addEventListener("touchstart", this.handleClick);
      } else {
        this.$el.parentNode.addEventListener("mouseenter", (event) => {
          if (!this.showTooltip) {
            this.calculateMousePosition(event);
            this.show();
          }
        });
        this.$el.parentNode.addEventListener("mouseleave", this.hide);
      }
    });
    window.addEventListener("resize", this.handleWidth);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
    this.$el.parentNode.removeEventListener("touchstart", this.handleClick);
    this.$el.parentNode.removeEventListener("mouseenter", this.show);
    this.$el.parentNode.removeEventListener("mouseleave", this.hide);
    window.addEventListener("resize", this.handleWidth);
    EventBus.$off("tooltip-opened", this.onTooltipOpened);
  },
};
</script>
